import _ from 'lodash';
import React from 'react';
import { Alert, Row } from 'react-bootstrap';
import { useQueryGetClaimableOrganizations } from 'hooks/queries';
import useFeatureFlags from 'hooks/featureFlags';
import { Loading } from 'components/loading/index';
import OrganizationsAbsent from './OrganizationsAbsent';
import OrganizationsPresent from './OrganizationsPresent';

const resolveOrganizations = ({
  claimableOrganizations, claimedOrganizations, unclaimedOrganizations, featureFlags,
}) => {
  const shouldClaim = claimableOrganizations?.length;
  const shouldOverride = claimedOrganizations?.length && featureFlags.allowOrgClaim;

  return (
    (shouldClaim && claimableOrganizations)
    || (shouldOverride && claimedOrganizations)
  );
};

const LinkOrganizationContent = ({
  setCurrentStepResult, result, active, handleLogout,
}) => {
  const featureFlags = useFeatureFlags();
  const { isLoading, error, data = {} } = useQueryGetClaimableOrganizations(active);

  if (isLoading) {
    return (<Loading centered message="Verifying Google organizations..." />);
  }
  if (error) {
    return (
      <Alert variant="danger">
        <div>We could not complete your request.</div>
        <Alert.Link onClick={() => window.location.reload()}>Refresh</Alert.Link>
        .
      </Alert>
    );
  }

  const { claimableOrganizations, gcpOrganizations, organizationClaims } = data;
  const [claimedOrganizations, unclaimedOrganizations] = _.partition(gcpOrganizations,
    (gcpOrg) => _.find(organizationClaims.organizations, { name: gcpOrg.name }));

  const availableOrganizations = resolveOrganizations({
    claimableOrganizations, claimedOrganizations, unclaimedOrganizations, featureFlags,
  });

  return (
    <Row>
      {
        availableOrganizations?.length
          ? (
            <OrganizationsPresent
              handleLogout={handleLogout}
              organizations={availableOrganizations}
              result={result}
              setCurrentStepResult={setCurrentStepResult}
            />
          )
          : (
            <OrganizationsAbsent
              handleLogout={handleLogout}
            />
          )
      }
    </Row>
  );
};

export default LinkOrganizationContent;
